export const ROUTES: Record<Uppercase<string>, Lowercase<string>> = {
  PRODUCT_LIST: 'landing_page',
  SEARCH_RESULTS: 'search_page',
  SELLER_PRODUCT_LIST: 'merchant_landing',
  UNIVERSE: 'universe_page',
}
